// src/SubscriptionUtils.js
import { db} from './firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

// Enhanced helper function to check if subscription is active
export const isSubscriptionActive = (subscription) => {
  if (!subscription) {
    
    return false;
  }

  

  const now = new Date();
  const isActive = subscription.status === 'active';

  let hasValidPeriod = true;
  if (subscription.currentPeriodEnd) {
    
    
    let periodEnd;
    
    // Handle different types of timestamp values
    if (subscription.currentPeriodEnd instanceof Date) {
      periodEnd = subscription.currentPeriodEnd;
    } else if (subscription.currentPeriodEnd.toDate && typeof subscription.currentPeriodEnd.toDate === 'function') {
      // Firestore Timestamp object
      periodEnd = subscription.currentPeriodEnd.toDate();
    } else if (typeof subscription.currentPeriodEnd === 'number') {
      // Unix timestamp (seconds or milliseconds)
      periodEnd = new Date(subscription.currentPeriodEnd * 1000); // Assuming seconds
    } else if (typeof subscription.currentPeriodEnd === 'string') {
      // ISO string
      periodEnd = new Date(subscription.currentPeriodEnd);
    } else {
      console.error('❌ Unknown timestamp format:', subscription.currentPeriodEnd);
      return false;
    }
    
    hasValidPeriod = periodEnd > now;
    
  }

  const isActiveResult = isActive && hasValidPeriod;
  

  return isActiveResult;
};

// Get user subscription status
export const getUserSubscription = async (userId) => {
  try {
      const subscriptionsRef = collection(db, 'subscriptions');
      const q = query(
        subscriptionsRef,
        where('userId', '==', userId)
      );
      
      const querySnapshot = await getDocs(q);
      
      let subscription = null;
      if (!querySnapshot.empty) {
        // Get the most recent subscription if multiple exist
        const subscriptions = [];
        querySnapshot.forEach((doc) => {
          subscriptions.push({ id: doc.id, ...doc.data() });
        });
        
        // Sort by updatedAt or createdAt to get the most recent
        subscriptions.sort((a, b) => {
          const aTime = a.updatedAt?.toDate?.() || a.createdAt?.toDate?.() || new Date(0);
          const bTime = b.updatedAt?.toDate?.() || b.createdAt?.toDate?.() || new Date(0);
          return bTime - aTime;
        });
        
        subscription = subscriptions[0];
      }
      
    return subscription;
  } catch (error) {
    console.error('Error getting user subscription:', error);
    return null;
  }
};

